/* Shopinfo - emissor de eventos (TASK-179) -> Shopify.analytics.publish ->
 * pixel "Shopinfo Eventos GA4". Formatos: .ai/automation/pixel-shopinfo/
 * README.md. Sem MutationObserver/scroll/resize/setInterval; falha = silencio. */
(function () {
  var D = document, W = window, Q = [], T = 0, tries = 0, BRL = 'BRL', last = new URLSearchParams(location.search);

  // Lote 500 ms/20; clique sai na hora. Sem publish: 20 tentativas.
  function flush() {
    clearTimeout(T);
    T = 0;
    var a = W.Shopify && Shopify.analytics;
    if (!a || !a.publish) {
      if (Q.length && tries++ < 20) T = setTimeout(flush, 500);
      return;
    }
    while (Q.length) {
      var x = Q.shift();
      try { a.publish('shopinfo:' + x[0], x[1]); } catch (e) {}
    }
  }

  function emit(n, p, now) {
    Q.push([n, p]);
    if (now || Q.length >= 20) flush();
    else if (!T) T = setTimeout(flush, 500);
  }

  function parts(el, a) { return (el.getAttribute(a) || '').split('|'); }
  function item(sku, cents) { return { item_id: sku, price: Math.round(+cents || 0) / 100, quantity: 1 }; }
  function cep5(c) { return String(c || '').replace(/\D/g, '').slice(0, 5); }
  function line() { return D.querySelector('[data-shipping-line]'); }

  function vid() {
    var n = D.getElementById('shopinfo-shipping-inline');
    return (n && n.dataset.variantId) || '';
  }

  function pid() {
    var l = line(), m = W.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    return (l && l.dataset.productId) || (m && String(m.id)) || '';
  }

  // E2/E3/E5 vem do `data-st` do inline.js; E1/E1-geo pelo botao original.
  function st(l) {
    if (l.classList.contains('is-loading')) return 'loading';
    var b = l.querySelector('[data-shipping-quote-pdp]');
    if (b) return b.textContent.trim() === (l.dataset.msgNotYourState || '').trim() ? 'E1-geo' : 'E1';
    return l.dataset.st || 'E1';
  }

  function promo(n, el) {
    var v = parts(el, 'data-shopinfo-promo'), p = { promotion_id: v[0], promotion_name: v[1], creative_slot: v[2], location_id: v[3], items: [] };
    if (v[4]) {
      p.items = [item(v[4], v[5])];
      p.currency = BRL;
    }
    emit(n, p, n === 'select_promotion');
  }

  function cta(control) {
    var c = W.Shopinfo && Shopinfo.calculator && Shopinfo.calculator.instance;
    emit('shipping_cta_click', { control: control, has_saved_cep: !!(c && c.savedCep) }, 1);
  }

  // Bolha: roda depois do handler do elemento.
  D.addEventListener('click', function (e) {
    try {
      var t = e.target, a, c, v, o;
      a = (t.closest ? t : t.parentElement).closest('a, button');
      if (!a) return;
      if (a.matches('.product-card__link, .shopinfo-card-link-overlay') && (c = a.closest('[data-shopinfo-item]'))) {
        v = parts(c, 'data-shopinfo-item');
        o = item(v[0], v[1]);
        o.item_list_name = v[2];
        if (v[3] === 'produtos') o.item_list_id = v[3]; // igual ao Simprosys
        o.index = [].indexOf.call((c.closest('.shopify-section') || D).querySelectorAll('[data-shopinfo-item]'), c);
        emit('select_item', { item_list_name: v[2], item_list_id: v[3], currency: BRL, items: [o] }, 1);
      } else if (a.tagName === 'A' && (c = a.closest('[data-shopinfo-promo]'))) {
        promo('select_promotion', c);
      } else if ((c = a.closest('[data-shopinfo-content]'))) {
        v = parts(c, 'data-shopinfo-content');
        o = { content_type: v[0], content_id: v[1] };
        if (v[2]) o.position = +v[2];
        emit('select_content', o, 1);
      } else if ((c = a.closest('[data-shopinfo-wa]'))) {
        v = parts(c, 'data-shopinfo-wa');
        o = { placement: v[0] };
        if (v[1]) {
          o.product_id = v[1];
          o.price_cents = +v[2] || 0;
        }
        emit('whatsapp_click', o, 1);
      } else if ((c = a.closest('[data-shipping-quote-pdp]'))) {
        c = c.closest('[data-shipping-line]');
        cta(c ? (st(c) === 'E1-geo' ? 'outro_estado' : 'ver_prazo') : 'botao');
      } else if (a.matches('.shopinfo-shipping-line__link, .shopinfo-shipping-inline__change')) {
        cta('alterar');
      }
    } catch (x) {}
  });

  function on(n, fn) {
    D.addEventListener('shopinfo:' + n, function (e) {
      try { fn(e.detail || {}); } catch (x) {}
    });
  }

  // inline.js manda rates/erro crus; status e corte do CEP aqui.
  on('shipping_quote_result', function (d) {
    var r = d.r || [], e = d.e, s = d.status, c = Infinity, n = Infinity;
    if (!s) s = e ? (e.name === 'AbortError' ? 'timeout' : e.shopinfoKind === 'coverage' ? 'no_coverage' : 'network') : r.length ? 'success' : 'no_coverage';
    var o = { status: s, mode: d.auto ? 'auto' : 'manual', cep_prefix: cep5(d.cep), rates: r.length, product_id: pid(), variant_id: vid(), from_cache: !!d.hit };
    if (r.length) {
      r.forEach(function (x) {
        c = Math.min(c, parseFloat(x.price));
        n = Math.min(n, parseInt(x.delivery_days_max != null ? x.delivery_days_max : x.delivery_days_min, 10));
      });
      o.free = c === 0;
      o.cheapest_cents = Math.round(c * 100);
      if (n < Infinity) o.earliest_days = n;
    }
    emit('shipping_quote_result', o);
  });

  on('cep_saved', function (d) {
    emit('cep_saved', { cep_source: d.cep_source === 'header' ? 'header' : 'pdp', cep_prefix: cep5(d.cep_prefix) });
  });

  on('geo_hint', function (d) {
    var uf = /^[A-Z]{2}$/.test(d.uf) ? d.uf : '', l = line();
    emit('geo_hint', { uf: uf, shown: !!(uf && l && st(l) === 'E1-geo') });
  });

  // diff da URL; sort_by sem repeticao
  D.addEventListener('filter:update', function () {
    try {
      var nx = new URLSearchParams(location.search), keys = {}, p = location.pathname, u = function (v, i, l) { return l.indexOf(v) == i; };
      var m = /\/collections\/([^/?#]+)/.exec(p), col = m ? decodeURIComponent(m[1]) : /\/search/.test(p) ? 'search' : '';
      [last, nx].forEach(function (s) {
        s.forEach(function (v, k) {
          if (/^filter\.|^sort_by$/.test(k)) keys[k] = 1;
        });
      });
      Object.keys(keys).forEach(function (k) {
        var a = last.getAll(k), b = nx.getAll(k), s = k == 'sort_by', o = s && !a.length && b.length && D.querySelector('[name=sort_by] [selected]');
        if (s) a = o ? [o.value] : a.filter(u), b = b.filter(u);
        if (a.slice().sort().join('\n') === b.slice().sort().join('\n')) return;
        var add = b.filter(function (v) { return a.indexOf(v) < 0; });
        var val = add.length ? add.join(',').slice(0, 60) : s ? 'default' : 'removed', n;
        if (add.length && k.indexOf('.price.') > 0 && !isNaN((n = parseFloat(add[0].replace(/\./g, '').replace(',', '.'))))) val = n;
        emit('filter_apply', { filter_key: s ? k : k.slice(7), filter_value: val, collection: col });
      });
      last = nx;
    } catch (x) {}
  });

  // Depois do load, em idle. UM observer, 50% visivel, 1x por elemento.
  function boot() {
    try {
      var so = D.querySelector('[data-shopinfo-view="soldout"]'), v;
      if (so) {
        v = parts(so, 'data-shopinfo-d'); // pid|preco_centavos|sku
        emit('soldout_view', { product_id: v[0], price_cents: +v[1] || 0, sku: v[2] || '' });
      }
      var els = D.querySelectorAll('[data-shopinfo-expose]');
      if (!els.length || !W.IntersectionObserver) return;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (x) {
          var el = x.target;
          if (!x.isIntersecting || x.intersectionRatio < 0.49) return;
          io.unobserve(el);
          try {
            if (el.getAttribute('data-shopinfo-expose') === 'promo') promo('view_promotion', el);
            else emit('shipping_line_exposed', { state: st(el), product_id: pid(), variant_id: vid(), pix_eligible: el.dataset.pixEligible === 'true' });
          } catch (y) {}
        });
      }, { threshold: 0.5 });
      [].forEach.call(els, function (el) { io.observe(el); });
    } catch (e) {}
  }

  function idle() {
    (W.requestIdleCallback || function (f) { setTimeout(f, 1000); })(boot);
  }

  if (D.readyState === 'complete') idle();
  else W.addEventListener('load', idle, { once: true });
  W.addEventListener('pagehide', flush);
})();
